import { useShallow } from 'zustand/react/shallow';
import { useAuthStore } from '../stores';

/**
 * Hook to access auth state and actions
 * @deprecated Use useAuthStore directly for better tree-shaking
 */
export const useAuth = () =>
  useAuthStore(
    useShallow((s) => ({
      user: s.user,
      isAuthenticated: s.isAuthenticated,
      loading: s.loading,
      hasPermission: s.hasPermission,
      loginWithAzure: s.loginWithAzure,
      logout: s.logout,
    }))
  );
